<template>
    <div class="c-date-goto-month">
        <label id="c-date-goto-month__select" class="c-date-goto-month__title">Jump to month</label>
        <v-select aria-labelledby="c-date-goto-month__select" :options="options" :searchable="false" v-model="selected" :value="selected" @input="chosenMonth"></v-select>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import vSelect from 'vue-select'
    import {EventBus} from "../event-bus"

    export default {
        name: "GotoMonth",
        components: {
            'v-select': vSelect
        },
        props: ['selectedMonth'],
        data() {
            return {
                selected: null,
                options: [],
            }
        },
        mounted() {
            this.fetchMonths()
            this.selected = this.selectedMonth
            EventBus.$on('updateMonth', this.updateSelector)
            EventBus.$on('jump-to-date', this.updateSelector)
        },
        methods: {
            chosenMonth(month) {
                let params = `month=${month.value}`
                const urlParams = new URLSearchParams(window.location.search)
                if (urlParams.has('accessibility')) {
                  params = `${params}&accessibility=${urlParams.get('accessibility')}`
                }
                window.history.replaceState(null, null, `?${params}`);
                EventBus.$emit('gotoMonth', month.value)
            },
            fetchMonths() {
               const params = {
                  action: 'basethemeCalendarMonthListRequest',
               }
               const urlParams = new URLSearchParams(window.location.search)
               if (urlParams.has('accessibility')) {
                 params.accessibility = urlParams.get('accessibility')
               }
                axios.get(window.wpAjax.url, {
                    params,
                }).then((response) => {
                    this.options = response.data.months
                }).catch(function (error) {
                    console.log(error)
                })
            },
            updateSelector(viewTitle) {
                this.selected = moment(viewTitle).format('MMMM YYYY')
            }
        }
    }
</script>

<style>
    @import '~vue-select/dist/vue-select.css'
</style>
